/**
 * Хелпер по работе с асинхроностью
 */
export default class AsyncHelper {
    /**
     * Функция debounce
     * @param callback
     * @param wait
     */
    static debounce = function <T extends unknown[], U>(
        callback: (...args: T) => PromiseLike<U> | U,
        wait = 100
    ) {
        let timer: NodeJS.Timeout;

        const debounceFn = function (...args: T): Promise<U> {
            clearTimeout(timer);
            return new Promise((resolve) => {
                timer = setTimeout(() => resolve(callback(...args)), wait);
            });
        };

        debounceFn.cancel = () => clearTimeout(timer);

        return debounceFn;
    };

    static async delay(ms: number = 1000, isSeconds: boolean = false) {
        const delayTime = isSeconds ? (ms * 1000) : ms;
        await new Promise(resolve => setTimeout(() => resolve(), delayTime))
    }
}
